<template>
  <!-- Expects Tailwind `group` on HorizontalAccordionItem and `.accordion-open` checkbox in Title. -->
  <div
    class="grid grid-rows-[0fr] transition-[grid-template-rows] duration-200
      ease-out group-has-[.accordion-open:checked]:grid-rows-[1fr]">
    <div class="overflow-hidden accordion-content">
      <div
        class="pt-0 transition-[padding-top] duration-200 ease-out
          group-has-[.accordion-open:checked]:pt-2">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
